// Simplified product image utility that uses canonical products directly
import { loadCanonicalProducts } from './productMatcher';

// Get the CDN base URL at runtime — works in both dev and embedded production contexts
function getCdnUrl() {
  if (typeof window !== 'undefined' && window.STORE_LOCATOR_CONFIG?.CDN_URL) {
    return window.STORE_LOCATOR_CONFIG.CDN_URL.replace(/\/$/, '');
  }
  if (
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname)
  ) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'https://ddeewr0txvw1f.cloudfront.net';
}

// Helper to prepend the CDN URL to relative image paths
function withPublicUrl(path) {
  if (!path) return path;
  
  // Handle absolute URLs (avoid modifying them)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Read at call time (runtime), not at module init time (build time)
  const base = getCdnUrl();
  
  // Avoid double slashes
  if (path.startsWith('/')) {
    return base + path;
  }
  
  return base + '/' + path;
}

// Default image for fallback
const DEFAULT_IMAGE = withPublicUrl('/products/good-vibes-500.jpg');

/**
 * Gets the image path for a given canonical product
 * @param {object} canonicalProduct - The canonical product object with imagePath property
 * @returns {string} The image path with public URL prepended
 */
export function getProductImagePath(canonicalProduct) {
  if (!canonicalProduct) return DEFAULT_IMAGE;
  
  // Prefer transparent image if available (eliminates card-in-card effect)
  if (canonicalProduct.transparentImagePath) {
    return withPublicUrl(canonicalProduct.transparentImagePath);
  }
  
  // Fall back to regular image
  if (canonicalProduct.imagePath) {
    return withPublicUrl(canonicalProduct.imagePath);
  }
  
  // Fallback to product category
  if (canonicalProduct.priceCategory === 'legacy') {
    return withPublicUrl('/products/good-feels.png');
  } else if (canonicalProduct.priceCategory === 'pocket') {
    return withPublicUrl('/products/good-vibes-pocket.png');
  } else if (canonicalProduct.priceCategory === 'rosin') {
    return withPublicUrl('/products/good-vibes.png');
  } else if (canonicalProduct.priceCategory === 'premium') {
    return withPublicUrl('/products/good-vibes-x.png');
  }
  
  return DEFAULT_IMAGE;
}

/**
 * Gets the video path for a given canonical product
 * @param {object} canonicalProduct - The canonical product object with videoPath property
 * @returns {string|null} The video path with public URL prepended, or null if no video
 */
export function getProductVideoPath(canonicalProduct) {
  if (!canonicalProduct || !canonicalProduct.videoPath) return null;
  
  return withPublicUrl(canonicalProduct.videoPath);
}

// Export all functions
export { withPublicUrl };
export default getProductImagePath;
